export enum ObservationSources {
  Provider1 = 'provider1',
  Provider2 = 'provider2',
}
